var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "primary--text event-line", attrs: { xs12: "", sm12: "" } },
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-avatar",
                { attrs: { size: "30" } },
                [
                  _vm._t("headerIcon", function() {
                    return [
                      _c("v-icon", { attrs: { size: "20" } }, [
                        _vm._v(_vm._s(_vm.mainIcon))
                      ])
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 font-weight-bold" }, [
                _vm._v(_vm._s(_vm.event.userDisplayName))
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "font-weight-light" },
                [
                  _vm._v(" [" + _vm._s(_vm.userCompanyName) + "] "),
                  _vm._t("default"),
                  _vm._v(" "),
                  _vm.showUserAgent
                    ? [
                        _vm._v(
                          "\n        using " +
                            _vm._s(_vm.event.chatAgent) +
                            "\n        "
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { staticClass: "pr-2" },
            [
              _vm.showUserAgent
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c("v-img", {
                                  staticClass: "agent-img pt-1",
                                  attrs: { width: "50", src: _vm.agentIcon },
                                  on: {
                                    click: function($event) {
                                      _vm.showVersion = !_vm.showVersion
                                    }
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2210184488
                      ),
                      model: {
                        value: _vm.showVersion,
                        callback: function($$v) {
                          _vm.showVersion = $$v
                        },
                        expression: "showVersion"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.event.chatAgentPlatform) +
                            " v" +
                            _vm._s(_vm.event.chatAgentVersion)
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74d1827e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d1827e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/ChatUserHeader.vue
// module id = null
// module chunks = 